var browserHandler = function() {
    let userAgent = window.navigator.userAgent;
    let isIE = (userAgent.indexOf("MSIE") > 0) || (userAgent.indexOf("Trident/") > 0);
    if (isIE) {
        var menuAdList = $("#menu-main .menu-type-consumer .menu-ad-list");
        menuAdList.find(".menu-ad-bg").hide();
        menuAdList.find(".menu-ad-title a").css("color", "#000000");
    }
};

// 調整瀏覽器寬度時，相對應調整主選單樣式
var settingMenuResize = function() {
    // 調整瀏覽器寬度時
    $(window).resize(function() {
        // 如果瀏覽器寬度小於960以下
        if (CheckWebsiteUnder960()) {
            // === 重設大版選單 (為了關閉大版選單) ===
            settingMenuLevel1Reset();
        }
    });
};

// 當滾動頁面時
var settingScrollTopMenu = function() {
    $(window).scroll(function(event) {
        // 當選單因下滑頁面置頂時，第1層選單 則要顯示為白底黑字的樣式
        settingMenuLevel1Style();
    });
};

// 當選單因下滑頁面置頂時，第1層選單 則要顯示為白底黑字的樣式
var settingMenuLevel1Style = function () {
    if (CheckUseRWDsizeNow()) {
        return false;
    }
    const headerBar = $("#header-bar");
    var scroll = $(window).scrollTop();
    if (scroll === 0) {
        if (headerBar.hasClass("showPcMenu")) {
            // 關閉第1層
            headerBar.removeClass("showPcMenu fixTop");
        }
    } else {
        if (!headerBar.hasClass("showPcMenu")) {
            // 關閉第1層
            headerBar.addClass("showPcMenu");
        }
    }
};

// 設定第1層選單
var settingMenuLevel1 = function() {

    const menuLevel1List = $("#menu-main .menu-level-1").find("li");
    const menuLevel2Container = $("#menu-main #menu-main-sub .sub-content-1");
    const menuLevel3Container = $("#menu-main #menu-main-sub .sub-content-2");
    const headerBar = $("#header-bar");

    $(menuLevel1List).each(function() {
        // 如果選單有子層，才綁定click事件
        if ($(this).attr("data-haschild") === "true") {

            $(this).bind("click",
                function() {

                    // 如果已經開啟選單，則關閉選單
                    if ($(this).hasClass("active")) {
                        // === 重設選單 ===
                        settingMenuLevel1Reset(true);
                        return;
                    }


                    // === 重設選單 ===
                    settingMenuLevel1Reset();


                    // === 打開選單 ===
                    // 開啟第1層
                    if (!CheckUseRWDsizeNow()) {
                        //showPcMenu只有首頁需要置頂，其它頁面不需要置頂。且打開選單時，一律置頂。
                        headerBar.addClass("showPcMenu fixTop");
                    }

                    // 關閉垂直捲軸
                    $("html").addClass("noscroll");

                    // 為背景加入模糊處理
                    //$(".Content-TopArea, #PageMainContent, footer").addClass("filter-blur");
                    // 點模糊區塊，關閉選單
                    //$(".Content-TopArea, #PageMainContent, footer").on("click",
                    //    function() {
                    //        settingMenuLevel1Reset();
                    //        return false;
                    //    });

                    // 為背景加入黑色透明區塊
                    $("div.topBg .blockTopMenuBackground").removeClass("show hidden").addClass("show");
                    // 點黑色透明區塊，關閉選單
                    $("div.topBg .blockTopMenuBackground").on("click",
                        function() {
                            settingMenuLevel1Reset();
                            return false;
                        });

                    // 第1層被選取
                    $(this).addClass("active");
                    const level1MenuId = $(this).attr("data-id");

                    // 修改第1層的上下箭頭
                    changeMenuLevel1Title(true, level1MenuId);

                    // 開啟第2層
                    menuLevel2Container.find("[data-parentId='" + level1MenuId + "']").removeClass("show hidden")
                        .addClass("show");
                    menuLevel2Container.slideDown(300, 'easeInOutCirc');

                    // 開啟第3層
                    var level2Menu = menuLevel2Container.find("[data-parentId='" + level1MenuId + "'] ul li.active")
                        .first();
                    if (level2Menu.length === 0) {
                        level2Menu = menuLevel2Container.find("[data-parentId='" + level1MenuId + "'] ul li").first();
                    }
                    const level2MenuId = level2Menu.attr("data-id");
                    menuLevel3Container.find("[data-parentId='" + level2MenuId + "']").removeClass("show hidden")
                        .addClass("show");
                    menuLevel3Container.slideDown(300, 'easeInOutCirc');

                    // 設定Enterprise選單中的內容
                    settingMenuTypeEnterpriseContent();
                });
        }
    });

};

// 重設第1層選單
var settingMenuLevel1Reset = function (isClose) {

    const menuLevel1List = $("#menu-main .menu-level-1").find("li");
    const menuLevel2Container = $("#menu-main #menu-main-sub .sub-content-1");
    const menuLevel3Container = $("#menu-main #menu-main-sub .sub-content-2");

    // 關閉第1層 (當選單因下滑頁面置頂時，第1層選單 則要顯示為白底黑字的樣式)
    settingMenuLevel1Style();

    // 關閉垂直捲軸
    $("html").removeClass("noscroll");

    // 取消背景模糊處理
    //$(".Content-TopArea, #PageMainContent, footer").removeClass("filter-blur");
    // 取消點模糊區塊，關閉選單
    //$(".Content-TopArea, #PageMainContent, footer").prop("onclick", null).off("click");

    // 取消背景黑色透明區塊
    $("div.topBg .blockTopMenuBackground").removeClass("show hidden").addClass("hidden");
    // 取消點黑色透明區塊，關閉選單
    $("div.topBg .blockTopMenuBackground").prop("onclick", null).off("click");

    // 取消選單第1層
    menuLevel1List.removeClass("active");

    // 修改第1層的上下箭頭
    changeMenuLevel1Title(false, 0);

    // 關閉第2層
    if (isClose) {
        menuLevel2Container.slideUp(300, 'easeInOutCirc');
    }
    menuLevel2Container.find(".menu-level-2").removeClass("show hidden").addClass("hidden");
   
    // 關閉第3層
    if (isClose) {
        menuLevel3Container.slideUp(300, 'easeInOutCirc');
    }
    menuLevel3Container.find(".menu-type-consumer,.menu-type-enterprise,.menu-type-solution,.menu-type-default").removeClass("show hidden")
        .addClass("hidden");
};

// 切換第1層選單文字
var changeMenuLevel1Title = function(isOpen, headerId) {
    if (headerId > 0) {
        $("#menu-main #menuLevel1-title-" + headerId + " svg").each(function() {
            if (isOpen) {
                $(this).addClass("RotationVertical");
            } else {
                $(this).removeClass("RotationVertical");
            }
        });
    } else {
        $("#menu-main .menu-level-1 li a .menuLevel1-arrow svg").each(function() {
            $(this).removeClass("RotationVertical");
        });
    }
};

// 設定第2層選單
var settingMenuLevel2 = function() {

    const menuLevel2List = $("#menu-main #menu-main-sub .sub-content-1 .menu-level-2").find("li");;
    const menuLevel3Container = $("#menu-main #menu-main-sub .sub-content-2");

    $(menuLevel2List).bind("click",
        function() {

            // 移除同層所有active樣式
            $(this).parent().find("li").removeClass("active");

            // 加入active樣式
            $(this).addClass("active");

            // 關閉第3層
            //menuLevel3Container.slideUp(300, 'easeInOutCirc');
            menuLevel3Container.find(".menu-type-consumer,.menu-type-enterprise,.menu-type-solution,.menu-type-default")
                .removeClass("show hidden")
                .addClass("hidden");

            // 開啟第3層
            //menuLevel3Container.slideDown(300, 'easeInOutCirc');
            const level2MenuId = $(this).attr("data-id");
            menuLevel3Container.find("[data-parentId='" + level2MenuId + "']").removeClass("show hidden")
                .addClass("show");

            // 設定Enterprise選單中的內容
            settingMenuTypeEnterpriseContent();
        });


};

// Consumer產品圖延遲處理判斷用
window.ConsumerImageMenuId = 0;

// 切換Consumer選單中的產品圖
var changeMenuTypeConsumerImage = function() {

    const menulevel3List = $("#menu-main .menu-type-consumer .menu-list").find(".menu-level-3");
    var menuAdList = $("#menu-main .menu-type-consumer .menu-ad-list");

    $(menulevel3List).on("mouseenter",
        function() {

            const dataId = $(this).attr("data-id");
            window.ConsumerImageMenuId = parseInt(dataId);

            $(this).off("mouseleave").on("mouseleave",
                function() {
                    window.ConsumerImageMenuId = 0;
                });

            // 因應使用者體驗關係，故意延遲0.3秒後，如果用戶仍停留在原產品線範圍，才切換右側產品圖
            setTimeout(
                function() {
                    if (parseInt(dataId) === window.ConsumerImageMenuId) {
                        menuAdList.find(".menu-ad-item").removeClass("show hidden").addClass("hidden");
                        menuAdList.find("[data-parentId='" + dataId + "']").removeClass("show hidden").addClass("show");
                    }
                },
                window.MenuHoverTimer);

        });
};

// 設定Consumer選單中的內容
var settingMenuTypeConsumerContent = function() {

    // 設定Consumer選單中的第4層選單的Click事件
    var linklList = $("#menu-main .menu-type-consumer .menu-list .menu-level-3 .menu-item a");
    linklList.each(function() {

        var url = $(this).attr("href");

        if (url.indexOf("#") >= 0) {
            $(this).bind("click",
                function() {
                    settingMenuLevel1Reset();
                    return;
                });
        }
    });
};

// 切換Enterprise選單中的第4層選單
var changeMenuTypeEnterpriseMenuLevel4 = function() {

    const menuLeft = $("#menu-main .menu-type-enterprise .menu-section-left");
    const menulevel3List = menuLeft.find("a");
    const menuCenter = $("#menu-main .menu-type-enterprise .menu-section-center");

    $(menulevel3List).bind("click",
        function() {

            //處理 menu-level-3，切換 active
            menuLeft.find("a").removeClass("active");
            $(this).addClass("active");

            //處理 menu-level-4 開關
            const dataId = $(this).attr("data-id");
            menuCenter.find(".menu-list").removeClass("show hidden").addClass("hidden");
            menuCenter.find("[data-parentId='" + dataId + "']").removeClass("show hidden").addClass("show");

            // 設定Enterprise選單中的內容
            settingMenuTypeEnterpriseContent();
        });

};

// 設定Enterprise選單中的內容
var settingMenuTypeEnterpriseContent = function() {

    // 設定Enterprise選單中的第5層選單的Hover樣式
    var ulList = $("#menu-main .menu-type-enterprise .menu-section-center .menu-list .menu-level-4 .menu-item ul");
    ulList.each(function() {
        var ulWidth = $(this).width();
        var liTotalWidth = 0;
        var liList = $(this).children("li");
        for (var i = 0; i < liList.length; i++) {
            liTotalWidth += liList.eq(i).width();
        }
        if (liTotalWidth > ulWidth) {
            $(this).addClass("lihover");
        } else {
            $(this).removeClass("lihover");
        }
    });


    // 設定Enterprise選單中的右側選單的產品圖連結
    var menuAdItemList = $("#menu-main .menu-type-enterprise .menu-section-right .menu-ad-list .menu-ad-item");
    $(menuAdItemList).bind("click",
        function() {

            var targetUrl = "";
            var targetType = "";
            if ($(this).find("a").first().length > 0) {
                targetUrl = $(this).find("a").first().attr("href");
                targetType = $(this).find("a").first().attr("target");
            }

            if (targetUrl === "") {
                return false;
            }

            if (targetType === "_blank") {
                window.open(targetUrl);
                return false;
            }

            window.location = targetUrl;
            return false;
        });
};



////David////////////////////////////////////////////////////////////////////////////////////////////////////////
// 切換Solution選單中的第4層選單
var changeMenuTypeSolutionMenuLevel4 = function () {

    const menuLeft = $("#menu-main .menu-type-solution .menu-section-left");
    const menulevel3List = menuLeft.find("a");
    const menuCenter = $("#menu-main .menu-type-solution .menu-section-center");

    $(menulevel3List).bind("click",
        function () {

            //處理 menu-level-3，切換 active
            menuLeft.find("a").removeClass("active");
            $(this).addClass("active");

            //處理 menu-level-4 開關
            const dataId = $(this).attr("data-id");
            menuCenter.find(".menu-list").removeClass("show hidden").addClass("hidden");
            menuCenter.find("[data-parentId='" + dataId + "']").removeClass("show hidden").addClass("show");
        });

};


